import {useEffect, useRef, useState} from 'react';
import Dialog from '@/components/Dialog';
import {Loading} from '@baidu/luffy-comp-loading';
import assert from 'assert';
import sdk from '@/sdk';
import * as store from '@/store';
import styles from './CopyProgress.module.scss';

interface ProgressProps {
    copyDocument?: {type: number, docGuid: string, title: string, hasChild?: boolean, isBatch?: boolean};
    onFinish: () => void;
    onTimeout?: () => void;
    onError?: () => void;
}

function CopyProgress({copyDocument, onFinish, onTimeout, onError}: ProgressProps) {
    const [totalCount, setTotalCount] = useState(0);
    const [successCount, setSuccessCount] = useState(0);
    const interval = useRef<any>(null); // 定时器检查复制进度
    const isBatch = copyDocument?.isBatch || false;

    // 清除定时器
    function clearCheckInterval() {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = null;
        }
    }

    async function checkCopyProgress() {
        try {
            assert(copyDocument);
            const {docGuid} = copyDocument;
            const repository = store.getCurRepository();
            assert(repository);
            const paramDocGuid = `${repository.repositoryGuid}:${sdk.as.user?.userGuid}`;
            const ksServer = await sdk.getKsServer(repository);
            const res = await ksServer.getCopyDocProgress(isBatch ? paramDocGuid : docGuid);
            if (!res) {
                return;
            }
            setTotalCount(res.totalCount);
            if (res.successCount > successCount) {
                setSuccessCount(res.successCount);
            }
            if (res.totalCount === res.successCount) {
                clearCheckInterval();
                onFinish();
            }
        } catch (err) {
            console.log(err);
        }
    }


    useEffect(() => {
        if ((copyDocument && isBatch) || (copyDocument && copyDocument?.docGuid)) {
            checkCopyProgress();
            let requestTimes = 1;
            interval.current = setInterval(() => {
                if (requestTimes >= 240) { // 轮询次数即2分钟兜底限制
                    clearCheckInterval();
                    onTimeout && onTimeout();
                }
                checkCopyProgress();
                requestTimes++;
            }, 500);
        } else {
            onError && onError();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            clearCheckInterval();
        };
    }, []);

    return (
        <Dialog
            visible
            className={styles.progressDialog}
            showCloseX={false}
            showHeader={false}
            maskCancel={false}
            destroyOnHide
        >
            <div style={{textAlign: 'center'}}>
                <div className={styles.progressTitle}>
                    <Loading visible className={styles.progressLoading} />
                    <span>正在复制，请稍候</span>
                </div>
                {
                    totalCount ?
                        <div className={styles.progressCount}>
                            <span>共{totalCount}篇页面，</span>
                            <span>正在复制第{successCount + 1 < totalCount ? successCount + 1 : totalCount}篇</span>
                        </div> : null
                }
            </div>
        </Dialog>
    );
}

const CopyProgressImpl = store.connect([
    store.KEYS.COPY_DOCUMENT,
])(CopyProgress);

export default CopyProgressImpl;
